import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  loaderSubject = new Subject<boolean>()
  loaderState = this.loaderSubject.asObservable()
  userInfo = new BehaviorSubject(Array)
  resizeColumnLoader = new BehaviorSubject({})
  filterUpdate = new BehaviorSubject({})
  checkboxSelection = new BehaviorSubject({})
  dropdownselectedInfo = new BehaviorSubject({})
  isInvoiceDataLoaded = new BehaviorSubject({})
  isUpdateTableData = new BehaviorSubject([])
  updatedTableDataL2 = new BehaviorSubject([])
  textboxUpdateValueInfo = new BehaviorSubject({})
  // custom component changes
  levelApproverCustomList = new BehaviorSubject(Array)
  approverCustomListForMemoChat = new BehaviorSubject([])
  userList = new BehaviorSubject(Array)
  customerSubGroupList = new BehaviorSubject(Array)
  openActivityInvoice = new BehaviorSubject(null)
  showDisputeSuccess = new BehaviorSubject({})
  updatedDisputeData = new BehaviorSubject({})
  autoCompleteClose = new BehaviorSubject({})
  showExportLoader = new BehaviorSubject(null)
  selectedInvoices = new BehaviorSubject([])
  reloadTable = new BehaviorSubject(null)

  lineItemUpdateCompleted = new Subject<void>()
  gapAmountDetails = new Subject<number>()
  updatedTableDataSubject = new Subject<any>()
  totalAmountColumnsSubject: BehaviorSubject<any> = new BehaviorSubject([])

  layouyCreated: BehaviorSubject<any> = new BehaviorSubject([])

  public messageSource = new BehaviorSubject('default message')
  currentMessage = this.messageSource.asObservable()
  changeMessage(message: string) {
    this.messageSource.next(message)
  }
}
